import $ from 'jquery'

$(document).on('turbolinks:load', function () {
  // Format existing values on page load
  $('[data-abn-field="true"]').each(function () {
    let value = $(this).val()
    if (value) {
      // Remove all non-numeric characters including decimals
      value = value.replace(/[^\d]/g, '')
      // Limit to 11 characters
      value = value.substring(0, 11)
      $(this).val(value)
    }
  })

  // Handle ABN field formatting - remove decimals and non-numeric characters
  $('[data-abn-field="true"]').on('input paste keyup', function () {
    let value = $(this).val()
    // Remove all non-numeric characters including decimals
    value = value.replace(/[^\d]/g, '')
    // Limit to 11 characters
    value = value.substring(0, 11)
    $(this).val(value)
  })

  // Prevent decimal point on keydown
  $('[data-abn-field="true"]').on('keydown', function (e) {
    // Prevent decimal point, comma, and other non-numeric characters
    if (
      e.key === '.' ||
      e.key === ',' ||
      e.key === '-' ||
      e.key === '+' ||
      e.key === 'e' ||
      e.key === 'E'
    ) {
      e.preventDefault()
      return false
    }
  })
})
